import { Icons } from '../../ui';

export default function ImageLoader() {
  return (
    <div className="flex w-full items-center justify-center">
      <Icons.InfiniteLoadingDotsIcon className="text-2xl text-gray-300" />
    </div>
  );
}
